module.exports = __webpack_public_path__ + "img/logo.71bdab2d.png";